<template>
    <p>
        {{ date }}
    </p>
    <p>
        {{ userStore.user.firstname }} {{ userStore.user.lastname }}
        <br />
        {{ userStore.user.address }}
        <br />
        {{ userStore.user.city }}, {{ userStore.user.state }} {{ userStore.user.zipcode }}
    </p>
    <p>
        {{ creditor.creditor_name }}
        <br />
        <template v-if="creditor.address">
            {{ creditor.address }}
        </template>
        <template v-else>
            {{ creditor.address_line }}<br /> {{ creditor.city }}, {{ creditor.state }} {{ creditor.zipcode }}
        </template>
    </p>
    <p>
        <b>
            RE: {{ userStore.user.ssn }}
        </b>
    </p>
    <div class="page">
        <p class="letter-content">
            To Whom It May Concern:
        </p>
        <p class="letter-content">
            This is my second time writing regarding the matter,
        </p>
        <p class="letter-content">
            In my previous correspondence I asked specifically for the deletion of the fraudulent account from my consumer.
        </p>
        <p class="letter-content">
            You {{ creditor.creditor_name }} replied and ignored all my request;
        </p>
        <p class="letter-content">
            You {{ creditor.creditor_name }} replied saying I have an obligation and a legal duty to pay child support! You {{ creditor.creditor_name }} further went on to say that all the information you are reporting is accurate! You {{ creditor.creditor_name }} insist that the account is validated with no proof to support your claim! 
        </p>
        <p class="letter-content">
            I asked you to validate this alleged debt! You did not, you {{ creditor.creditor_name }} are in clear violation of 12 CFR 1006.34 notice of validation of debts.
        </p>
        <p class="letter-content">
            You were asked to provide the personal responsibly contract as per your own words that I have a legal duty to perform! Obligations arise out of contract.
        </p>
        <p class="letter-content">
            Where is the contract that I asked for between me {{ userStore.user.firstname }} {{ userStore.user.lastname }} and the head of Depart of Health and Human Services (DHHS).
        </p>
        <p class="letter-content">
            Further More where is the proof that this debt and the alleged child is mine? Where is the proof? Send me the proof?
        </p>
        <p class="letter-content">
            You fraudulently enrolled me into a program using an identification of me with out lawful authority! Let stop you in your tracks before you respond to saying some shit that is not true! You might be thinking you have a lawful authority to use my personal information without my consent! This cannot be further from the truth! There is no law NONE that says I {{ userStore.user.firstname }} {{ userStore.user.lastname }} a natural flesh and blood being that was created in the image and likeness of the most must pay the United States treasury or any entity or state any support! Title I-VD was not created to benefit the custodial parent or the child. 875 F. 2d 1558 - Wehunt v. G Ledbetter.
        </p>
        <p class="letter-content">
            There is no right granted to any person for child support <b>Blessing v. Freestone, 520 U.S. 329 (1997)</b>
        </p>
        <p class="letter-content">
            Your offenses amount to <b>Aggravated Identity Theft</b> pursuant to 18 U.S.C. §1028A and 15 USC 1681q. You have knowingly transferred, possessed, or used, without lawful authority, a means of identification of me, which is a felony punishable with up to 2 years of imprisonment, in addition to civil liability.
        </p>
        <p class="letter-content">
            you {{ creditor.creditor_name }} have committed a serious offense of fraud! you {{ creditor.creditor_name }} have stolen my identity, you have caused severe harm to my character, my reputation, my mode of living, my finances, my freedom and you will be held responsible.
        </p>
        <p class="letter-content">
            This entire ordeal is biased from the start because you and your agents have a financial interest in the matter! I was not treated fairly I was not treated equally, you enabled someone <b>[Child Mother or Child Father Name]</b> to steal and provide you with my personal information without my consent. 
        </p>
        <p class="letter-content">
            you {{ creditor.creditor_name }} then used this stolen information to further enable the fraud by enrolling me {{ userStore.user.firstname }} {{ userStore.user.lastname }} into a program without my consent.
        </p>
        <p class="letter-content">
            DELETE this fraudulent account from my consumer reports immediately! 
        </p>
        <p class="letter-content">
            If you fail to delete this alleged debt and fraudulent account from my consumer reports my next correspondence to you will be legal action.
        </p>
        <p>
            {{ userStore.user.firstname }} {{ userStore.user.lastname }}
            <br />
            {{ userStore.user.address }}
            <br />
            {{ userStore.user.city }}, {{ userStore.user.state }} {{ userStore.user.zipcode }}
        </p>
    </div>
</template>
<script>
    import { ref, reactive, computed } from 'vue'
    import { useUserStore } from '../../stores/UserStore.js'
    import moment from 'moment';
    import lodash from 'lodash'
    export default {
        props: {
            accounts: {
                type: [Array, Object]
            },
            creditor: {
                type: [Array, Object]
            }
        },
        setup(props) {
            return {
                date: ref(moment().format('LL')),
                userStore: useUserStore(),
                lodash: lodash
            };
        },
    };
</script>